/* global moment:true, _:true*/
(function () {
  'use strict';

  angular.module('eDocumentsApp').controller('DocumentController', DocumentController);

  DocumentController.$inject = [
    '$state',
    '$scope',
    '$uibModal',
    '$translate',
    'DataUtils',
    'Document',
    'ParseLinks',
    'AlertService',
    'paginationConstants',
    'Notification',
    'PaginationUtil',
    'DocumentDownloadPdf',
    'CurrencyUtils',
    '$window',
    'Principal',
  ];

  function DocumentController(
    $state,
    $scope,
    $uibModal,
    $translate,
    DataUtils,
    Document,
    ParseLinks,
    AlertService,
    paginationConstants,
    Notification,
    PaginationUtil,
    DocumentDownloadPdf,
    CurrencyUtils,
    $window,
    Principal
  ) {
    var vm = this;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.exportDocumentsFiles = exportDocumentsFiles;
    vm.exportSelectedDocsToExcel = exportSelectedDocsToExcel;
    vm.exportSelectedDocsToCSV = exportSelectedDocsToCSV;
    vm.exportAllDocsAsCSV = exportAllDocsAsCSV;
    vm.search = search;
    vm.reset = reset;
    vm.loadAll = loadAll;
    vm.initFilters = initFilters;
    vm.totalItems = 1000;
    vm.isTableLoading = true;
    vm.deselectOne = deselectOne;
    vm.selectAll = selectAll;
    vm.selectChange = selectChange;
    vm.getTotalSelected = getTotalSelected;
    vm.viewSelectedDocuments = viewSelectedDocuments;
    vm.viewFavoriteSearches = viewFavoriteSearches;
    vm.isSearchActive = isSearchActive;
    vm.getCurrency = CurrencyUtils.getCurrency;
    vm.download = download;
    vm.changeFiles = changeFiles;
    vm.changeVisualization = changeVisualization;
    vm.changeDocumentType = changeDocumentType;
    vm.changeStatus = changeStatus;
    vm.getViewableFilename = DataUtils.getViewableFilename;
    vm.formatFileSize = DataUtils.formatFileSize;
    vm.getFileIconClass = DataUtils.getFileIconClass;
    vm.types = ['INVOICE', 'CREDITNOTE', 'DEBITNOTE', 'SELFBILLED', 'PROFORMAINVOICE', 'CONSIGNMENTNOTE', 'ORDER', 'DESPATCHADVICE'];
    vm.states = ['IN_COMMUNICATION', 'PROCESSING', 'WAITING', 'SCHEDULED', 'FINISHED', 'ERROR', 'DUPLICATED'];

    var debouncedLoadAll = _.debounce(loadAll, 300);

    vm.documentsToExport = {};

    vm.clearInputDate = clearInputDate;
    vm.startDateForCreatedDate = null;
    vm.endDateForCreatedDate = null;
    vm.startDateForDocumentDate = null;
    vm.endDateForDocumentDate = null;

    // #33: the Tipo and Estado choices used to go vertical on `vm.width < 660`, a width read only on a window resize —
    // so a phone that had just loaded the page kept them in one row running off the screen. They now wrap in CSS
    // (.ed-choice-group), which needs no width and no window handler.

    function isSearchActive() {
      return (
        vm.filters.filterBy.documentNumber.value ||
        vm.filters.filterBy.originName.value ||
        vm.filters.filterBy.destinationName.value ||
        vm.filters.filterBy.originVatRegistrationNumber.value ||
        vm.filters.filterBy.destinationVatRegistrationNumber.value ||
        vm.filters.filterBy.entityName.value ||
        vm.filters.filterBy.entityVatRegistrationNumber.value ||
        vm.filters.filterBy.createdDate.startDate ||
        vm.filters.filterBy.createdDate.endDate ||
        vm.filters.filterBy.documentDate.startDate ||
        vm.filters.filterBy.documentDate.endDate ||
        vm.filters.filterBy.documentValue.startValue ||
        vm.filters.filterBy.documentValue.startValue === 0 ||
        vm.filters.filterBy.documentValue.endValue ||
        vm.filters.filterBy.documentValue.endValue === 0 ||
        vm.filters.filterBy.documentType.value ||
        vm.filters.filterBy.hasViews.value ||
        vm.filters.filterBy.hasFiles.value ||
        vm.filters.filterBy.status.value
      );
    }

    function changeVisualization(value) {
      vm.filters.filterBy.hasViews.value = value;
      vm.page = 1;
      debouncedLoadAll();
    }

    function changeFiles(value) {
      vm.filters.filterBy.hasFiles.value = value;
      vm.page = 1;
      debouncedLoadAll();
    }

    function changeDocumentType(value) {
      vm.filters.filterBy.documentType.value = value;
      vm.page = 1;
      debouncedLoadAll();
    }

    function changeStatus(value) {
      vm.filters.filterBy.status.value = value;
      vm.page = 1;
      debouncedLoadAll();
    }

    function reset() {
      vm.filters = PaginationUtil.clearFilters($state.current.name, filterBy());
      loadAll();
    }

    function filterBy() {
      return {
        documentNumber: {
          name: 'documentNumber',
          value: undefined,
        },
        originName: {
          name: 'originName',
          value: undefined,
        },
        destinationName: {
          name: 'destinationName',
          value: undefined,
        },
        originVatRegistrationNumber: {
          name: 'originVatRegistrationNumber',
          value: undefined,
        },
        destinationVatRegistrationNumber: {
          name: 'destinationVatRegistrationNumber',
          value: undefined,
        },
        entityName: {
          name: 'entityName',
          value: undefined,
        },
        entityVatRegistrationNumber: {
          name: 'entityVatRegistrationNumber',
          value: undefined,
        },
        createdDate: {
          name: 'createdDate',
          startDate: undefined,
          endDate: undefined,
        },
        documentDate: {
          name: 'documentDate',
          startDate: undefined,
          endDate: undefined,
        },
        documentValue: {
          name: 'documentValue',
          startValue: undefined,
          endValue: undefined,
        },
        documentType: {
          name: 'documentType',
          value: undefined,
        },
        hasViews: {
          name: 'hasViews',
          value: undefined,
        },
        hasFiles: {
          name: 'hasFiles',
          value: undefined,
        },
        status: {
          name: 'status',
          value: undefined,
        },
      };
    }

    function initFilters() {
      vm.filters = PaginationUtil.getFilters($state.current.name, filterBy());

      vm.page = vm.filters.currentPage + 1;
      vm.predicate = vm.filters.orderBy;
      vm.reverse = vm.filters.orderReverse;
      loadAll();
    }

    vm.$onInit = function () {
      initFilters();
    };

    function loadAll() {
      vm.filters = PaginationUtil.updateFilters($state.current.name, vm.page - 1, vm.filters.filterBy, vm.predicate, vm.reverse, vm.itemsPerPage);
      Document.query(
        {
          page: vm.filters.currentPage,
          size: vm.filters.itemsPerPage,
          search: search(),
          sort: sort(),
        },
        onSuccess,
        onError
      );
    }

    function onSuccess(data, headers) {
      vm.links = ParseLinks.parse(headers('link'));
      vm.totalItems = headers('X-Total-Count');
      vm.queryCount = vm.totalItems;
      // EDOCS-652 Phase 2: each row's files come with the page (DocumentViewDTO.files); no second request.
      vm.documents = data;

      for (var i = 0; i < vm.documents.length; i++) {
        if (vm.documentsToExport[vm.documents[i].id] != null) {
          vm.documents[i].selected = true;
        }
      }
      checkSelectAll();
    }

    function onError(error) {
      AlertService.error(error.data.message);
    }

    function sort() {
      if (!vm.predicate) {
        vm.predicate = 'createdDate';
      }
      var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
      if (vm.predicate !== 'createdDate') {
        result.push('createdDate,desc');
      }
      return result;
    }

    function search() {
      var result = '';
      for (var x in vm.filters.filterBy) {
        if (x === 'hasViews') {
          if (vm.filters.filterBy[x] && vm.filters.filterBy[x].value) {
            if (vm.filters.filterBy[x].value === '1') {
              result += vm.filters.filterBy[x].name + ':true#AND,';
            } else if (vm.filters.filterBy[x].value === '0') {
              result += vm.filters.filterBy[x].name + ':false#AND,';
            }
          }
        } else if (x === 'hasFiles') {
          if (vm.filters.filterBy[x] && vm.filters.filterBy[x].value) {
            if (vm.filters.filterBy[x].value === '1') {
              result += vm.filters.filterBy[x].name + ':true#AND,';
            } else if (vm.filters.filterBy[x].value === '0') {
              result += vm.filters.filterBy[x].name + ':false#AND,';
            }
          }
        } else {
          if (vm.filters.filterBy[x] && vm.filters.filterBy[x].value) {
            result += vm.filters.filterBy[x].name + ':' + vm.filters.filterBy[x].value + '#AND,';
          }
          if (vm.filters.filterBy[x] && vm.filters.filterBy[x].startDate) {
            if (x === 'documentDate') {
              result +=
                vm.filters.filterBy[x].name +
                '>=' +
                moment(vm.filters.filterBy[x].startDate, 'DD/MM/YYYY')
                  .tz('Europe/Lisbon')
                  .set({
                    hours: 0,
                    minutes: 0,
                    seconds: 0,
                  })
                  .toISOString(true) +
                '#AND,';
            } else {
              result +=
                vm.filters.filterBy[x].name +
                '>=' +
                moment(vm.filters.filterBy[x].startDate, 'DD/MM/YYYY HH:mm')
                  .tz('Europe/Lisbon')
                  .set({
                    seconds: 0,
                  })
                  .toISOString(true) +
                '#AND,';
            }
          }
          if (vm.filters.filterBy[x] && vm.filters.filterBy[x].endDate) {
            if (x === 'documentDate') {
              result +=
                vm.filters.filterBy[x].name +
                '<=' +
                moment(vm.filters.filterBy[x].endDate, 'DD/MM/YYYY')
                  .tz('Europe/Lisbon')
                  .set({
                    hours: 23,
                    minutes: 59,
                    seconds: 59,
                  })
                  .toISOString(true) +
                '#AND,';
            } else {
              result +=
                vm.filters.filterBy[x].name +
                '<=' +
                moment(vm.filters.filterBy[x].endDate, 'DD/MM/YYYY HH:mm')
                  .tz('Europe/Lisbon')
                  .set({
                    seconds: 59,
                  })
                  .toISOString(true) +
                '#AND,';
            }
          }
          if (vm.filters.filterBy[x] && (vm.filters.filterBy[x].startValue || vm.filters.filterBy[x].startValue === 0)) {
            result += vm.filters.filterBy[x].name + '>=' + vm.filters.filterBy[x].startValue + '#AND,';
          }
          if (vm.filters.filterBy[x] && (vm.filters.filterBy[x].endValue || vm.filters.filterBy[x].endValue === 0)) {
            result += vm.filters.filterBy[x].name + '<=' + vm.filters.filterBy[x].endValue + '#AND,';
          }
        }
      }

      return result;
    }

    function download($event, document, fileId, fileType) {
      DocumentDownloadPdf.download($event, document, fileId, fileType);
    }

    function viewSelectedDocuments() {
      $uibModal.open({
        templateUrl: 'app/entities/document/selected-documents-dialog.html',
        controller: 'SelectedDocumentsController',
        controllerAs: 'vm',
        size: 'xl',
        resolve: {
          list: vm.documentsToExport,
          selectChange: function () {
            return vm.selectChange;
          },
          exportDocumentsFiles: function () {
            return vm.exportDocumentsFiles;
          },
          exportSelectedDocsToCSV: function () {
            return vm.exportSelectedDocsToCSV;
          },
          exportSelectedDocsToExcel: function () {
            return vm.exportSelectedDocsToExcel;
          },
        },
      });
    }

    function viewFavoriteSearches() {
      $uibModal
        .open({
          templateUrl: 'app/entities/document/favorite-searches-dialog.html',
          controller: 'FavoriteSearchesController',
          controllerAs: 'vm',
          size: 'xl',
          resolve: {
            documentTypes: function () {
              return vm.types;
            },
            documentStates: function () {
              return vm.states;
            },
            filterBy: function () {
              return filterBy;
            },
          },
        })
        .result.then(
          function (response) {
            vm.filters.filterBy = response;
            vm.page = 1;
            vm.loadAll();
          },
          function () {}
        );
    }

    function checkSelectAll() {
      var docsSelected = vm.documents.filter(function (doc) {
        return vm.documentsToExport[doc.id] != null;
      });
      vm.selectedAll = docsSelected.length === vm.documents.length;
    }

    function getTotalSelected() {
      var keys = Object.keys(vm.documentsToExport);
      return keys.length;
    }

    function selectChange(document) {
      if (document.selected) {
        vm.documentsToExport[document.id] = document;
        checkSelectAll();
      } else {
        delete vm.documentsToExport[document.id];
      }
    }

    // runs on the checkbox's ng-change, so vm.selectedAll is already the new value (by mouse or keyboard alike)
    function selectAll() {
      vm.documents.map(function (x) {
        x.selected = vm.selectedAll;
        return x;
      });
      if (vm.selectedAll) {
        for (var i = 0; i < vm.documents.length; i++) {
          vm.documentsToExport[vm.documents[i].id] = vm.documents[i];
        }
      } else {
        for (var j = 0; j < vm.documents.length; j++) {
          delete vm.documentsToExport[vm.documents[j].id];
        }
      }
    }

    function deselectOne() {
      vm.selectedAll = false;
    }

    function exportDocumentsFiles() {
      var docsSelected = [];
      Object.keys(vm.documentsToExport).forEach(function (key) {
        docsSelected.push(vm.documentsToExport[key]);
      });
      if (docsSelected.length === 0) {
        Notification.error({ message: $translate.instant('eDocumentsApp.document.message.noDocumentsSelected') });
        return;
      }
      var ids = [];
      for (var i = 0; i < docsSelected.length; i++) {
        if (docsSelected[i].files.length > 0) {
          ids.push(docsSelected[i].id);
        }
      }
      Document.downloadAsZip(ids).$promise.then(
        function (result) {
          Document.addDownloads(ids);
          DataUtils.viewServerFile(result);
          for (var i = 0; i < vm.documents.length; i++) {
            vm.documents[i].selected = false;
            selectChange(vm.documents[i]);
          }
        },
        function () {
          Notification.error({ message: $translate.instant('eDocumentsApp.document.message.fileRetrievalError') });
        }
      );
    }

    var opts = {
      sheetid: $translate.instant('eDocumentsApp.document.export.title'),
      headers: true,
      columns: [
        {
          columnid: 'documentNumber',
          title: $translate.instant('eDocumentsApp.document.documentNumber'),
          width: 'auto',
        },
        {
          columnid: 'createdDate',
          title: $translate.instant('eDocumentsApp.document.createdDate'),
          width: 'auto',
        },
        {
          columnid: 'documentDate',
          title: $translate.instant('eDocumentsApp.document.documentDate'),
          width: 'auto',
        },
        {
          columnid: 'documentType',
          title: $translate.instant('eDocumentsApp.document.documentType'),
          width: 'auto',
        },
        {
          columnid: 'documentValue',
          title: $translate.instant('eDocumentsApp.document.documentValue'),
          width: 'auto',
        },
        {
          columnid: 'currency',
          title: $translate.instant('eDocumentsApp.document.currency'),
          width: 'auto',
        },
        {
          columnid: 'origin',
          title: $translate.instant('eDocumentsApp.document.origin.label'),
          width: 'auto',
        },
        {
          columnid: 'destination',
          title: $translate.instant('eDocumentsApp.document.destination.label'),
          width: 'auto',
        },
        {
          columnid: 'status',
          title: $translate.instant('eDocumentsApp.document.status'),
          width: 'auto',
        },
        {
          columnid: 'files',
          title: $translate.instant('eDocumentsApp.document.documentFiles'),
          width: 'auto',
          cell: {
            value: function (value) {
              var result = '';
              if (value.length > 0) {
                for (var i = 0; i < value.length; i++) {
                  if (i > 0) {
                    result = result + ', ';
                  }
                  result = result + value[i].filename;
                }
              }
              return result;
            },
          },
        },
      ],
      row: {
        style: function (sheet, row, rowidx) {
          return 'height:20px';
        },
      },
    };

    function exportSelectedDocsToExcel() {
      var docsSelected = [];
      Object.keys(vm.documentsToExport).forEach(function (key) {
        docsSelected.push(vm.documentsToExport[key]);
      });
      if (docsSelected.length === 0) {
        Notification.error({ message: $translate.instant('eDocumentsApp.document.message.noDocumentsSelected') });
        return;
      }
      alasql('SELECT * INTO XLS("documents_' + new Date().getTime() + '.xls",?) FROM ?', [opts, docsSelected]);
    }

    function exportSelectedDocsToCSV() {
      var docsSelected = [];
      Object.keys(vm.documentsToExport).forEach(function (key) {
        docsSelected.push(vm.documentsToExport[key]);
      });
      if (docsSelected.length === 0) {
        Notification.error({ message: $translate.instant('eDocumentsApp.document.message.noDocumentsSelected') });
        return;
      }
      alasql(
        'SELECT documentNumber, createdDate, documentDate, documentType, documentValue, currency, origin, destination, status INTO CSV("documents_' +
          new Date().getTime() +
          '.csv",{headers:true}) FROM ?',
        [docsSelected]
      );
    }

    function exportAllDocsAsCSV() {
      if (vm.totalItems > 15000) {
        $uibModal.open({
          templateUrl: 'app/entities/document/export-all-documents-error-dialog.html',
          controller: 'ExportAllDocumentsErrorController',
          controllerAs: 'vm',
          size: 'lg',
          resolve: {
            numberOfDocuments: { total: vm.totalItems },
          },
        });
      } else {
        var search = { search: vm.search() };
        Document.downloadAllDocsCSV(search).$promise.then(
          function (result) {
            DataUtils.viewServerFile(result);
          },
          function () {
            Notification.error({ message: $translate.instant('eDocumentsApp.document.message.fileRetrievalError') });
          }
        );
      }
    }

    function clearInputDate(input) {
      if (input === 'startDateForCreatedDate') {
        vm.startDateForCreatedDate = null;
        vm.filters.filterBy.createdDate.startDate = null;
      } else if (input === 'endDateForCreatedDate') {
        vm.endDateForCreatedDate = null;
        vm.filters.filterBy.createdDate.endDate = null;
      } else if (input === 'startDateForDocumentDate') {
        vm.startDateForDocumentDate = null;
        vm.filters.filterBy.documentDate.startDate = null;
      } else if (input === 'endDateForDocumentDate') {
        vm.endDateForDocumentDate = null;
        vm.filters.filterBy.documentDate.endDate = null;
      }
    }
  }
})();
